import React from 'react'
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Typography } from '@mui/material'
import { ExpandMore } from '@mui/icons-material'

const AccordionPreset = ({ children, name, label, accordionExpanded, onAccordionChange, onSubmit }) => {
  const formEl = React.useRef(null)

  const submit = evt => {
    evt.preventDefault()

    if (!formEl.current.reportValidity()) {
      return
    }

    onSubmit()
  }

  return (
    <Accordion className={`preset-rule-${name}`}
               expanded={accordionExpanded}
               TransitionProps={{ mountOnEnter: true, unmountOnExit: true }}
               onChange={onAccordionChange}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="body1">{label}</Typography>
        <Box className="flex-grow-1"></Box>
        <Box visibility={accordionExpanded ? 'visible' : 'hidden'}>
          <Button type="submit" form={`form-preset-${name}`}
                  className="submit" color="primary" size="small"
                  onClick={evt => evt.stopPropagation()}>
            設定
          </Button>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <form id={`form-preset-${name}`} ref={formEl}
              noValidate onSubmit={submit}>
          {children}
        </form>
      </AccordionDetails>
    </Accordion>
  )
}

export default AccordionPreset
